module.exports = __webpack_public_path__ + "static/media/flag.ef591379.png";